<div
  class="boundary-review-popup"
  [class.boundary-review-popup--minimized]="windowState() === 'minimized'"
  [class.boundary-review-popup--expanded]="windowState() === 'expanded'"
>
  <div class="boundary-review-popup__header">
    <div class="boundary-review-popup__header-left">
      <img src="assets/images/rsa-demo/boundary-agent-icon-new.png" alt="" class="boundary-review-popup__header-icon" />
      <span class="boundary-review-popup__header-title">Boundary agent</span>
    </div>
    <div class="boundary-review-popup__header-controls">
      <button type="button" class="boundary-review-popup__control-btn" (click)="onToggleMinimize()">
        @if (windowState() === 'minimized') {
          <lucide-icon name="maximize-2" [size]="14" [strokeWidth]="2"></lucide-icon>
        } @else {
          <lucide-icon name="minus" [size]="14" [strokeWidth]="2"></lucide-icon>
        }
      </button>
      @if (windowState() !== 'minimized') {
        <button type="button" class="boundary-review-popup__control-btn" (click)="onToggleExpand()">
          @if (windowState() === 'expanded') {
            <lucide-icon name="minimize-2" [size]="14" [strokeWidth]="2"></lucide-icon>
          } @else {
            <lucide-icon name="maximize-2" [size]="14" [strokeWidth]="2"></lucide-icon>
          }
        </button>
      }
      <button type="button" class="boundary-review-popup__control-btn" (click)="onClose()">
        <lucide-icon name="x" [size]="14" [strokeWidth]="2"></lucide-icon>
      </button>
    </div>
  </div>

  @if (windowState() !== 'minimized') {
    <div class="boundary-review">
      <div class="boundary-review__content">
        <div class="boundary-review__section">
          <h3 class="boundary-review__section-title">Create boundary</h3>
          <p class="boundary-review__section-subtitle">
            Review and apply a suggested runtime boundary based on this detected pattern.<br />
            You can always edit or disable it on the Runtime Boundaries page.
          </p>

          <div class="boundary-review__issue-group">
            <div class="boundary-review__field">
              <span class="boundary-review__field-label">Issue</span>
            </div>
            <div class="boundary-review__issue-card">
              <div class="boundary-review__issue-info">
                <img [src]="issueResourceIcon" alt="" class="boundary-review__issue-icon" />
                <span class="boundary-review__issue-name">{{ issueName }}</span>
              </div>
              <app-severity-label [severity]="'critical'"></app-severity-label>
            </div>
            <div class="boundary-review__divider"></div>
          </div>

          <div class="boundary-review__ai-message">
            <img
              src="assets/images/agent/agent-avatar-with-circle-around.svg"
              alt=""
              class="boundary-review__ai-avatar"
            />
            <div class="boundary-review__ai-message-content">
              <div class="boundary-review__ai-block">
                <p class="boundary-review__field-text">
                  {{ boundaryText.analysis }}
                </p>

                @if (boundaryText.attackSteps.length > 0) {
                  <ol class="boundary-review__attack-steps">
                    @for (step of boundaryText.attackSteps; track step) {
                      <li class="boundary-review__field-text">{{ step }}</li>
                    }
                  </ol>
                }
              </div>

              <div class="boundary-review__ai-block boundary-review__ai-block--impact">
                <p class="boundary-review__field-text boundary-review__field-text--label">Impact</p>
                <p class="boundary-review__field-text" [innerHTML]="boundaryText.impact"></p>
                <p class="boundary-review__field-text" [innerHTML]="boundaryText.testing"></p>
              </div>

              <p class="boundary-review__field-text">Want me to walk you through the details, or ready to apply?</p>

              @if (applyState() === 'idle') {
                <div class="boundary-review__actions">
                  <button type="button" class="boundary-review__action-button" (click)="onApplyBoundary()">
                    Apply boundary
                  </button>
                </div>
              }
            </div>
          </div>

          @if (applyState() !== 'idle') {
            <div class="boundary-review__actions boundary-review__actions--end">
              <button
                type="button"
                class="boundary-review__action-button boundary-review__action-button--user-response"
              >
                Apply boundary
              </button>
            </div>
          }

          @if (applyState() === 'analyzing' || applyState() === 'validating' || applyState() === 'deploying') {
            <div class="boundary-review__cot">
              <img
                src="assets/images/agent/agent-avatar-with-circle-around.svg"
                alt=""
                class="boundary-review__ai-avatar"
              />
              <p class="boundary-review__cot-text">
                @if (applyState() === 'analyzing') {
                  Analyzing attack pattern...
                }
                @if (applyState() === 'validating') {
                  Validating against normal workflows...
                }
                @if (applyState() === 'deploying') {
                  Deploying boundary...
                }
              </p>
            </div>
          }

          @if (applyState() === 'done') {
            <div class="boundary-review__ai-message">
              <img
                src="assets/images/agent/agent-avatar-with-circle-around.svg"
                alt=""
                class="boundary-review__ai-avatar"
              />
              <div class="boundary-review__ai-message-content">
                <p class="boundary-review__field-text">
                  The boundary is now active. The agent will be blocked before any sensitive data reaches an external
                  destination.<br />
                  You can view, edit, or disable it anytime on the Runtime Boundaries page.<br />
                  Let me know if you'd like to adjust anything.
                </p>
              </div>
            </div>
          }
        </div>
      </div>

      <div class="boundary-review__footer">
        <div class="boundary-review__input-container">
          <input type="text" class="boundary-review__input" placeholder="Ask a question or request changes..." />
          <button type="button" class="boundary-review__send-button">
            <lucide-icon name="arrow-right" [size]="16" [strokeWidth]="2"></lucide-icon>
          </button>
        </div>
        <p class="boundary-review__disclaimer">AI can make mistakes. Verify important information.</p>
      </div>
    </div>
  }
</div>
